<template>
  <div class="shadow-edit__settings" :class="{ 'shadow-edit__settings--mobile': isMobile }">
        <div class="shadow-edit__settings__item shadow-edit__settings__item--inline">
          <div class="shadow-edit__settings__title">
            {{ $t('shadow.is-shadow') }}
          </div>
          <div class="shadow-edit__settings__content">
            <v-switch v-model="shadowParams.isShadow" hide-details />
          </div>
        </div>
        <div v-if="shadowParams.isShadow" class="shadow-edit__settings__item mb-4">
          <div class="shadow-edit__settings__title">
            {{ $t('shadow.settings-shadow-type') }}
          </div>
          <v-spacer />
          <div class="shadow-edit__settings__content shadow-edit__settings__content--padding">
            <shadow-type v-model="shadowParamsType" />
          </div>
        </div>
        <div class="shadow-edit__settings__item mb-4">
          <div class="shadow-edit__settings__title">
            {{ $t('shadow.background-color') }}
          </div>
          <v-spacer />
          <div class="shadow-edit__settings__content shadow-edit__settings__content--padding">
            <colors-list
              :key="keyCustom"
              v-model="shadowParams.shadowColor"
              :no-empty-color="shadowParams.isShadow"
              :additional-colors="[{ color: '#ffffff', id: '1' }]"
            />
          </div>
        </div>
        <div class="shadow-edit__settings__item mb-4">
          <div class="shadow-edit__settings__title mb-0">
            {{ $t('shadow.settings-padding') }}
          </div>

          <div class="shadow-edit__settings__content">
            <div class="shadow-edit__settings__padding">
              <!-- <ai-clear-button
                      v-for="(item, index) in paddingList"
                      :key="index"
                      class="shadow-edit__settings__padding__item"
                      :class="{ 'shadow-edit__settings__padding__item--active': paddingIndex === index }"
                      @click="setPadding(index)"
                    >
                      <div class="shadow-edit__settings__padding__item__icon"></div>
                      <v-spacer />
                      <div class="shadow-edit__settings__padding__item__value">
                        {{ item }}%
                      </div>
                    </ai-clear-button> -->
              <ai-clear-button
                class="shadow-edit__settings__padding__item"
                :class="{ 'shadow-edit__settings__padding__item--active': shadowParams.paddingIndex === -1 }"
                @click="setPadding(-1)"
              >
                <div class="shadow-edit__settings__padding__item__icon"></div>
                <div class="shadow-edit__settings__padding__item__text">{{ $t('shadow.bigger-size') }}</div>
                <v-spacer />
                <div class="shadow-edit__settings__padding__item__value">
                  <v-text-field v-model.number.lazy="shadowParams.padding" class="shadow-edit__input" hide-details />
                </div>
              </ai-clear-button>
              <ai-clear-button
                class="shadow-edit__settings__padding__item shadow-edit__settings__padding__item--custom"
                :class="{ 'shadow-edit__settings__padding__item--active': shadowParams.paddingIndex === -2 }"
                @click="setPadding(-2)"
              >
                <div class="shadow-edit__settings__padding__item__icon"></div>
                <div class="shadow-edit__settings__padding__item__text">{{ $t('editor.settings.custom') }}</div>
                <v-spacer />
                <div class="shadow-edit__settings__padding__item__value">
                  <div class="shadow-edit__settings__padding__item__value__row">
                    <div class="shadow-edit__settings__padding__item__value__row__item">
                      <v-text-field
                        v-model.number.lazy="shadowParams.paddingTop"
                        class="shadow-edit__input"
                        hide-details
                      >
                        <template v-slot:prepend-inner>
                          <inline-svg style="min-width: 15px" :src="require('@/assets/icons/shadow/padding-top.svg')" />
                        </template>
                      </v-text-field>
                    </div>
                    <div class="shadow-edit__settings__padding__item__value__row__item">
                      <v-text-field
                        v-model.number.lazy="shadowParams.paddingRight"
                        class="shadow-edit__input"
                        hide-details
                      >
                        <template v-slot:prepend-inner>
                          <inline-svg
                            style="min-width: 15px"
                            :src="require('@/assets/icons/shadow/padding-right.svg')"
                          />
                        </template>
                      </v-text-field>
                    </div>
                  </div>
                  <div class="shadow-edit__settings__padding__item__value__row">
                    <div class="shadow-edit__settings__padding__item__value__row__item">
                      <v-text-field
                        v-model.number.lazy="shadowParams.paddingLeft"
                        class="shadow-edit__input"
                        hide-details
                      >
                        <template v-slot:prepend-inner>
                          <inline-svg
                            style="min-width: 15px"
                            :src="require('@/assets/icons/shadow/padding-left.svg')"
                          />
                        </template>
                      </v-text-field>
                    </div>
                    <div class="shadow-edit__settings__padding__item__value__row__item">
                      <v-text-field
                        v-model.number.lazy="shadowParams.paddingBottom"
                        class="shadow-edit__input"
                        hide-details
                      >
                        <template v-slot:prepend-inner>
                          <inline-svg
                            style="min-width: 15px"
                            :src="require('@/assets/icons/shadow/padding-bottom.svg')"
                          />
                        </template>
                      </v-text-field>
                    </div>
                  </div>
                </div>
              </ai-clear-button>
            </div>
          </div>
        </div>
        <div class="shadow-edit__settings__item shadow-edit__settings__item--inline">
          <div class="shadow-edit__settings__title">
            {{ $t('common.size') }}
          </div>
          <div class="shadow-edit__settings__content">
            <canvas-sizes
              :key="keyCustom"
              v-model:height="shadowParamsCanvasHeight"
              v-model:width="shadowParamsCanvasWidth"
            />
          </div>
        </div>
        <div class="shadow-edit__settings__item">
          <div class="shadow-edit__settings__title">
            {{ $t('common.position') }}
          </div>
          <div class="shadow-edit__settings__content">
            <position-list />
          </div>
        </div>
        <div class="shadow-edit__settings__item shadow-edit__settings__item--inline">
          <div class="shadow-edit__settings__title">
            {{ $t('shadow.settings-format') }}
          </div>
          <div class="shadow-edit__settings__content">
            <v-select
              v-model="shadowParamsFormat"
              class="shadow-edit__settings__select"
              menu-icon="mdi-chevron-down"
              hide-details
              :items="formats"
              eager
            />
          </div>
        </div>
    <ai-button
      v-if="isMobile"
      :disabled="generationLoading"
      theme="gradient-primary"
      @click="shadowFileHandler"
      style="width: 100%"
      class="shadow-edit__settings__button mt-2"
    >
      <template v-if="!generationLoading">
        {{ $t('shadow.create-shadow') }}
      </template>
      <time-counter v-else />
    </ai-button>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useEventBus } from '@vueuse/core';

import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';

import ColorsList from '@/components/common/ColorsList/ColorsList.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';
import CanvasSizes from '@/components/pages/Shadow/CanvasSizes/CanvasSizes.vue';
import PositionList from '@/components/pages/Shadow/PositionList/PositionList.vue';
import ShadowType from '@/components/pages/Shadow/ShadowType/ShadowType.vue';

const { t } = useI18n();

const busError = useEventBus<string>('toast-error');

const { generateImage } = useServicesStore();

const { isMobile } = storeToRefs(useCommonStore());
const {
  generationLoading,
  shadowParams,
  imageForActions,
  shadowParamsCanvasHeight,
  shadowParamsCanvasWidth,
  shadowParamsFormat,
  shadowParamsType,
  imagePrev,
  imageResult,
} = storeToRefs(useServicesStore());

const settingsTab = ref<'presets' | 'custom'>('custom');
const key = ref<number>(0);
const keyCustom = ref<number>(0);

const formats = computed(() => {
  let result = [{
    title: 'PNG',
    value: 0,
  }];
  if (shadowParams.value.shadowColor !== '') {
    result = [
      {
        title: 'JPEG',
        value: 1,
      },
      {
        title: 'PNG',
        value: 0,
      },
    ];
  }
  return result;
});

const setPadding = (index: number): void => {
  shadowParams.value.paddingIndex = index;
};

const shadowFileHandler = (): void => {
  generationLoading.value = true;

  let paddingInt = {};
  if (shadowParams.value.paddingIndex === -2) {
    paddingInt = {
      left_pad: shadowParams.value.paddingLeft,
      right_pad: shadowParams.value.paddingRight,
      bottom_pad: shadowParams.value.paddingBottom,
      top_pad: shadowParams.value.paddingTop,
    };
  } else if (shadowParams.value.paddingIndex === -1) {
    paddingInt = {
      left_pad: shadowParams.value.padding,
      right_pad: shadowParams.value.padding,
      bottom_pad: shadowParams.value.padding,
      top_pad: shadowParams.value.padding,
    };
  }

  generateImage({
    action: 'shadow',
    image: removeBase64Prefix(imageForActions.value),
    params: {
      form: shadowParamsFormat.value,
      mode: shadowParamsType.value,
      padding: paddingInt,
      shadow: shadowParams.value.isShadow,
      color: shadowParams.value.shadowColor === '' ? null : shadowParams.value.shadowColor,
      size: {
        height: shadowParamsCanvasHeight.value,
        width: shadowParamsCanvasWidth.value,
      },
    },
  })
    .then((res) => {
      imagePrev.value = imageForActions.value;
      imageForActions.value = `data:image/png;base64,${res.payload.imageWithPadding}`;
      imageResult.value = `data:image/png;base64,${res.image}`;
      // sourceShadowImg.value = `data:image/png;base64,${res.payload.imageWithPadding}`;
    })
    .catch((e) => {
      busError.emit(e?.error || t('common.err-gen'));
    })
    .finally(() => {
      generationLoading.value = false;
    });
};

watch(settingsTab, (newVal) => {
  if (newVal === 'presets') {
    key.value += 1;
  } else {
    keyCustom.value += 1;
    shadowParams.value.shadowColor = '#ffffff';
    shadowParams.value.paddingLeft = 0;
    shadowParams.value.paddingRight = 0;
    shadowParams.value.paddingBottom = 0;
    shadowParams.value.paddingTop = 0;
    shadowParams.value.position = 'center';
  }
});

watch(
  () => shadowParams.value.isShadow,
  (newVal) => {
    if (newVal === true && shadowParams.value.shadowColor === '') {
      shadowParams.value.shadowColor = '#ffffff';
    }
  },
);
watch(
  () => shadowParams.value.shadowColor,
  (newVal) => {
    if (newVal === '') {
      shadowParamsFormat.value = 0;
    }
  },
);
</script>

<style scoped lang="scss" src="./ShadowSettings.scss" />
